import {
	TEST_SHACK_REPORT_STATUS,
	type TestShackReportStatus,
} from "../models/TestShackReport";

// Report display: fixed 3 decimals with thousands separators (12.500, 1,234.500),
// aligned with M1 and the entry forms.
export const formatMeasurement = (value: number | null) =>
	value === null
		? "-"
		: value.toLocaleString("en-US", {
				minimumFractionDigits: 3,
				maximumFractionDigits: 3,
			});

export const formatRevision = (
	revision: number | null,
	subRevision: number | null,
) =>
	revision === null
		? "-"
		: subRevision === null
			? `Rev ${revision}`
			: `Rev ${revision}.${subRevision}`;

/** Numeric out-of-spec check; M1 also counts NO_GO gauges in its own helper. */
export const isOutOfSpec = (status: TestShackReportStatus) =>
	status === TEST_SHACK_REPORT_STATUS.OVER ||
	status === TEST_SHACK_REPORT_STATUS.UNDER;

export const STATUS_LABEL: Record<TestShackReportStatus, string> = {
	[TEST_SHACK_REPORT_STATUS.IN]: "In spec",
	[TEST_SHACK_REPORT_STATUS.GO]: "GO",
	[TEST_SHACK_REPORT_STATUS.NO_GO]: "NG",
	[TEST_SHACK_REPORT_STATUS.OVER]: "Over",
	[TEST_SHACK_REPORT_STATUS.UNDER]: "Under",
	[TEST_SHACK_REPORT_STATUS.NO_SPEC]: "No spec",
};

interface OutOfSpecSummary {
	outOfSpecCount: number;
	hasTolerances: boolean;
}

export const formatOutOfSpec = ({
	outOfSpecCount,
	hasTolerances,
}: OutOfSpecSummary) => {
	// Without a specification nothing can be judged, so no count either.
	if (!hasTolerances) return "No Specification";
	return outOfSpecCount > 0 ? `${outOfSpecCount} out of spec` : "All in spec";
};
